import { MathPage, MathHeader, useScope } from "@/components/MathShell";
import { GeometryTool } from "@/components/math/GeometryTool";

export default function MathGeometry() {
  const [scope] = useScope();
  return (
    <MathPage crumbs={["Geometri Çizim"]} scope={scope}>
      <MathHeader title="Geometri Çizim Aracı" sub="Üçgen, açı, çokgen, çember ve fonksiyon grafiklerini kesin ölçülerle çizin; PNG olarak indirin veya soru editöründen soruya ekleyin." />
      <div className="bg-white rounded-xl border p-5"><GeometryTool /></div>
    </MathPage>
  );
}
